import React, { useState, useMemo, useEffect } from "react"
import { Row, Col, Card, Table } from "reactstrap"
import { useTable, useSortBy, usePagination, useGlobalFilter } from "react-table"
import Loader from "pages/Separate/Loader"
import NewPagination from "components/Common/Newpagination"
import secureLocalStorage from "react-secure-storage"
import { customGlobalFilter } from "utils/common-helpers"
import {
  pendingInvoiceColumns,
  ReceiptsInvoiceColumns,
  requestedInvoiceColumns,
} from "utils/columns/ElementsColumns/financeColumns"
import { fetchData, fetchNodeData, FetchNodePostData, FetchPostData } from "utils/common-fetchData"
import Swal from "sweetalert2"
import axios from "axios"
import moment from "moment"
import html2pdf from "html2pdf.js"
import configure from "configure"
import { useNavigate } from "react-router-dom"

const isPrivilegedUser = [1, 32, 4, 46].includes(Number(localStorage?.getItem("auth_id")))

const COMPANY_TABS = [
  ...(isPrivilegedUser ? [{ key: "all", label: "All" }] : []),
  { key: "ztpl", label: "ZTPL" },
  { key: "zithas", label: "Zithas" },

]

function TableContainer({
  columns, data, allData, status, setStatus, setData,
  staticPendingCustomer, totalReceipts, setTotalReceipts,
}) {
  const {
    getTableProps, getTableBodyProps, headerGroups, page, state,
    previousPage, nextPage, canPreviousPage, canNextPage,
    gotoPage, setPageSize, pageOptions, setGlobalFilter, pageCount, prepareRow,
  } = useTable(
    {
      columns, data,
      globalFilter: customGlobalFilter,
      autoResetPage: false,
      initialState: { sortBy: [{ id: "id", desc: true }] },
    },
    useGlobalFilter, useSortBy, usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  const [ztplReceipts, setZtplReceipts] = useState([])
  const [zithasReceipts, setZithasReceipts] = useState([])
  const [finalReceipts, setFinalReceipts] = useState([])
  const [invoiceType, setInvoiceType] = useState(isPrivilegedUser ? "all" : "ztpl")

  useEffect(() => { setPageSize(10) }, [])

  const getReceiptsList = () => {
    if (!allData) return []
    const ztplList = Array.isArray(allData?.ztpl_invoice)
      ? allData.ztpl_invoice.filter(inv => inv.due_flag == 1 && inv.receipt_status == 0 && inv.tax_inv_no !== null).map(inv => ({ ...inv, invoiceType: "ztpl" }))
      : []
    const zithasList = Array.isArray(allData?.zithas_invoice)
      ? allData.zithas_invoice.filter(inv => inv.due_flag == 1).map(inv => ({ ...inv, invoiceType: "zithas" }))
      : []
    const merged = [...ztplList, ...zithasList]
    setZtplReceipts(ztplList)
    setZithasReceipts(zithasList)
    setFinalReceipts(merged)
    return merged
  }

  useEffect(() => { if (allData) getReceiptsList() }, [allData])

  const ztplPending = allData?.ztpl_invoice?.filter(inv => inv?.due_flag == 0 && inv.approve == 1) || []
  const zithasPending = allData?.zithas_invoice?.filter(inv => inv?.due_flag == 0 && inv.approve == 1) || []
  const allPending = [...ztplPending, ...zithasPending]
  const allReceipts = [...(ztplReceipts || []), ...(zithasReceipts || [])]

  const pendingCount = invoiceType === "ztpl" ? ztplPending.length : invoiceType === "zithas" ? zithasPending.length : allPending.length
  const receiptsCount = invoiceType === "ztpl" ? ztplReceipts?.length || 0 : invoiceType === "zithas" ? zithasReceipts?.length || 0 : allReceipts.length

  const switchCompany = type => {
    setInvoiceType(type)
    // reset to pending view for the new company
    setStatus(type)
    if (type === "ztpl") setData(ztplPending)
    else if (type === "zithas") setData(zithasPending)
    else setData(allPending)
  }

  const SUB_TABS = [
    { key: invoiceType, label: "Pending Invoices", count: pendingCount },
    ...(isPrivilegedUser ? [
      { key: `${invoiceType}-receipts`, label: "Receipts", count: receiptsCount },
      { key: "requested", label: "Lead Requested", count: staticPendingCustomer?.length || 0 },
    ] : []),
  ]

  const activeSubKey = status

  const onSubTabClick = key => {
    setStatus(key)
    if (key === "requested") {
      setData(staticPendingCustomer)
    } else if (key.includes("receipts")) {
      if (invoiceType === "ztpl") setData(ztplReceipts || [])
      else if (invoiceType === "zithas") setData(zithasReceipts || [])
      else setData(allReceipts)
    } else {
      if (invoiceType === "ztpl") setData(ztplPending)
      else if (invoiceType === "zithas") setData(zithasPending)
      else setData(allPending)
    }
  }

  return (
    <div>
      {/* Single merged toolbar row */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">

        {/* Left: company pills ▸ divider ▸ sub-tabs ▸ show-entries */}
        <div className="d-flex align-items-center gap-2 flex-wrap">

          {/* Company pills */}
          {COMPANY_TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => switchCompany(tab.key)}
              className="btn btn-sm fw-semibold"
              style={{
                borderRadius: "20px",
                padding: "3px 14px",
                border: invoiceType === tab.key ? "2px solid #752a97" : "2px solid #dee2e6",
                color: invoiceType === tab.key ? "#752a97" : "#6c757d",
                background: invoiceType === tab.key ? "#f5eef8" : "transparent",
                transition: "all 0.15s",
              }}
            >
              {tab.label}
            </button>
          ))}

          {/* Vertical divider */}
          <span style={{ width: "1px", height: "22px", background: "#dee2e6", display: "inline-block" }} />

          {/* Sub-tabs */}
          {SUB_TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => onSubTabClick(tab.key)}
              className="btn btn-sm fw-semibold"
              style={{
                borderRadius: "6px",
                padding: "3px 10px",
                border: activeSubKey === tab.key ? "1.5px solid #752a97" : "1.5px solid #dee2e6",
                color: activeSubKey === tab.key ? "#fff" : "#752a97",
                background: activeSubKey === tab.key ? "#752a97" : "transparent",
                transition: "all 0.15s",
                whiteSpace: "nowrap",
              }}
            >
              {tab.label} <strong>({tab.count})</strong>
            </button>
          ))}

          {/* Vertical divider */}
          <span style={{ width: "1px", height: "22px", background: "#dee2e6", display: "inline-block" }} />

          {/* Show entries */}
          <select
            className="form-select form-select-sm"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 25, 50, 100].map(s => (
              <option key={s} value={s}>Show {s}</option>
            ))}
          </select>
        </div>

        {/* Right: search */}
        <div className="position-relative" style={{ minWidth: "180px" }}>
          <input
            onChange={e => setGlobalFilter(e.target.value)}
            type="text"
            className="form-control form-control-sm"
            placeholder="Search..."
            value={globalFilter || ""}
            style={{ paddingLeft: "28px", borderRadius: "6px" }}
          />
          <i className="bx bx-search-alt" style={{ position: "absolute", top: "50%", left: "8px", transform: "translateY(-50%)", color: "#aaa", fontSize: "14px" }}></i>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table className="table table-bordered mb-0" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex align-items-center">
                      <span className="flex-grow-1 text-center header-text">{column.render("Header")}</span>
                      {column.isShortIcon && (
                        <span onClick={() => column.getSortByToggleProps().onClick()} className="d-flex align-items-center ms-1">
                          <i className={`bi bi-arrow-up info-icon ${column.isSorted && !column.isSortedDesc ? "text-dark" : ""}`}></i>
                          <i className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc ? "text-dark" : ""}`}></i>
                        </span>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr className="row-hover" {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, index) => (
                    <td key={index} className={`t-col-${index + 1} ${cell.column.className}`} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center mt-2">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>
    </div>
  )
}

const DashPendingInvoices = () => {
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])
  const [paymentMode, setPaymentMode] = useState(false)
  const [paymentOption, setPaymentOption] = useState([])
  const token = secureLocalStorage.getItem("auth_token")
  const [invoiceDetail, setInvoiceDetail] = useState({})
  const [transactionId, setTransactionId] = useState("")
  const [payment, setPayment] = useState([])
  const [receivedDate, setReceivedDate] = useState("")
  const [amount, setAmount] = useState("")
  const [tds, setTds] = useState("")
  const [transactionCharge, setTransactionCharge] = useState("")
  const [description, setDescription] = useState("")
  const [historyData, setHistoryData] = useState([])
  const [status, setStatus] = useState(isPrivilegedUser ? "all" : "ztpl")
  const [isEditMode, setEditMode] = useState(false)
  const [editingPaymentId, setEditingPaymentId] = useState(null)
  const [pendingCustomer, setPendingCustomer] = useState([])
  const [leadId, setLeadId] = useState("")
  const [tempCustomerId, setTempCustomerId] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [customerDetails, setCustomerDetails] = useState({})
  const [invoiceOpen, setInvoiceOpen] = useState(false)
  const [invoiceNo, setInvoiceNo] = useState("")
  const [totalReceipts, setTotalReceipts] = useState()
  const [columnKey, setColumnKey] = useState(false)
  const navigate = useNavigate()

  const toggleLoading = loading => setLoading(loading)

  const resetForm = () => {
    setTransactionId(""); setPayment([]); setReceivedDate(""); setAmount("")
    setTds(""); setTransactionCharge(""); setDescription("")
    setEditMode(false); setEditingPaymentId(null)
  }

  const onPaymentRecord = async obj => {
    const res = await fetchData(
      toggleLoading,
      status === "zithas" ? `zithasPaymentHistory/${obj?.id}` : `paymentHistory/${obj?.id}`,
      token
    )
    if (res?.success) {
      setHistoryData(res?.data?.history)
      setPaymentMode(true)
      setInvoiceDetail({ ...obj, due_amount: res?.data?.due_amount })
    }
  }

  const onCovertTax = id => {
    Swal.fire({ icon: "warning", title: "Are You Sure ?", text: "You Want to Convert Tax to Invoice?", showCancelButton: true, confirmButtonText: "Yes, convert it!", cancelButtonText: "No, cancel!" })
      .then(async result => {
        if (result?.isConfirmed) {
          const res = await fetchData(toggleLoading, `convert_invoice/${id}`, token)
          if (res.success) {
            Swal.fire({ icon: "success", title: "Invoice Converted Successfully" }).then(() => {
              setData(res.data.ztpl_invoice.filter(inv => inv.due_flag == 0 && inv.approve == 1))
              setAllData(res.data)
            })
          }
        }
      })
  }

  const onDownloadReceipt = async obj => {
    const isZithas = obj.invoiceType === "zithas" || status === "zithas"
    const res = await fetchData(toggleLoading, isZithas ? `zithasPaymentHistory/${obj.id}` : `paymentHistory/${obj.id}`, token)
    if (res?.success) {
      const history = res?.data?.history
      const totalAmount = history.reduce((sum, cur) => sum + Number(cur.amount), 0)
      const htmlContent = `<html><body style="font-family:Calibri,sans-serif;"><div><div style="text-align:right"><div>Zithas Technologies Pvt. Ltd.</div><div>FF-16 Kalpvrux Complex, Opp. GEB Substation, Gotri Road, Vadodara Gujarat, 390021, India</div><div>GSTIN 24AABCZ2004K1ZL</div><div>www.zithas.com</div></div><div style="text-align:center;font-size:25px;font-weight:bold;border-bottom:1px solid grey;">INVOICE RECEIPT</div><br/><div style="display:flex;"><div style="width:50%"><div>Invoice Number: ${obj?.tax_inv_no || obj?.invoice_number}</div><div>Date of Issue: ${moment(obj?.created_at).format("DD-MM-YYYY")}</div></div><div style="width:50%;text-align:right"><div>Bill To,</div><div>${obj?.c_company}</div><div>${obj?.c_address}, ${obj?.city}, ${obj?.state}, ${obj?.country}, ${obj?.c_zipcode}</div></div></div><p style="font-size:20px">Invoice History</p><table style="width:100%;border-collapse:collapse;border:1px solid #c6c6c6"><thead><tr><th style="border:1px solid #c6c6c6">Id</th><th style="border:1px solid #c6c6c6">Date</th><th style="border:1px solid #c6c6c6">Payment</th><th style="border:1px solid #c6c6c6">Transaction</th><th style="border:1px solid #c6c6c6">TDS</th><th style="border:1px solid #c6c6c6">Amount</th></tr></thead><tbody>${history?.map((h, i) => `<tr><td style="border:1px solid #c6c6c6;text-align:center">${i + 1}</td><td style="border:1px solid #c6c6c6;text-align:center">${moment(h?.receive_date).format("DD-MM-YYYY")}</td><td style="border:1px solid #c6c6c6;text-align:center">${h?.payment_mode}</td><td style="border:1px solid #c6c6c6;text-align:center">${h?.transaction_id || "-"}</td><td style="border:1px solid #c6c6c6;text-align:center">${h?.tds || "-"}</td><td style="border:1px solid #c6c6c6;text-align:center">${h?.amount}</td></tr>`).join("")}</tbody></table><br/><div style="text-align:right"><b>Total:</b> ${totalAmount}</div><br/><div style="text-align:center">This receipt confirms that the above invoice has been paid in full.</div></div></body></html>`
      html2pdf().from(htmlContent).set({ margin: 10, filename: `Invoice Receipt-${obj?.tax_inv_no || obj?.invoice_number}.pdf`, html2canvas: { scale: 2 }, jsPDF: { unit: "mm", format: "a4", orientation: "portrait" } }).save()
      const response = await fetchData(toggleLoading, isZithas ? `changeZithasReceiptStatus/${obj?.id}` : `changeReceiptStatus/${obj?.id}`, token)
      if (response?.success) {
        Swal.fire({ icon: "success", text: "Receipt Downloaded Successfully" }).then(() => {
          setData(isZithas ? response?.data?.zithas_invoice : response?.data?.ztpl_invoice)
          setAllData(response?.data)
        })
      }
    }
  }

  const changeStatusLead = async (id, status) => {
    return await FetchNodePostData(setLoading, "leadCOPstatus", token, { lead_id: id, status })
  }

  const onCreateInvoice = async (type, obj) => {
    Swal.fire({ icon: "warning", title: "Are You Sure ?", text: "You Want to Create Invoice?", showCancelButton: true, confirmButtonText: "Yes, create it!", cancelButtonText: "No, cancel!" })
      .then(async isOkay => {
        if (isOkay?.isConfirmed) {
          const res = await changeStatusLead(obj?.id, 3)
          if (res?.data?.success) {
            if (type == "ztpl") navigate(`${configure.appUrl}performa_invoice/ztpl#lead-${obj?.temp_customer}`)
            else if (type == "zithas") navigate(`${configure.appUrl}invoice/zithas_invoice#lead-${obj?.temp_customer}`)
          }
        }
      })
  }

  const onCreateCustomer = async (id, edit, obj) => {
    setLeadId(id)
    if (edit == "edit") {
      const res = await fetchNodeData(setLoading, `tempCustomer/${obj?.temp_customer}`, token)
      if (res?.success) { setIsEdit(true); setCustomerDetails(res?.data) }
    } else { setIsEdit(false) }
  }

  const onInvoicePaid = obj => { setInvoiceOpen(true); setLeadId(obj?.id); setTempCustomerId(obj?.temp_customer) }

  const column1 = useMemo(() => {
    if (status == "requested") return requestedInvoiceColumns(onCreateCustomer, onCreateInvoice, onInvoicePaid)
    if (status.includes("receipts")) return ReceiptsInvoiceColumns(onPaymentRecord, onCovertTax, onDownloadReceipt, status)
    return pendingInvoiceColumns(onPaymentRecord, onCovertTax, onDownloadReceipt, status, isPrivilegedUser)
  }, [status, columnKey])

  const fetchInvoices = async () => {
    const res = await fetchData(toggleLoading, "invoiceData", token)
    if (res?.data) {
      const authId = Number(localStorage?.getItem("auth_id"))
      const filterByBA = inv => isPrivilegedUser || Number(inv?.assignedBA) === authId
      const ztplInvoices = (res.data.ztpl_invoice || []).filter(filterByBA)
      const zithasInvoices = (res.data.zithas_invoice || []).filter(filterByBA)
      const filteredAllData = { ...res.data, ztpl_invoice: ztplInvoices, zithas_invoice: zithasInvoices }
      const initType = isPrivilegedUser ? "all" : "ztpl"
      const invoices = initType === "ztpl" ? ztplInvoices : zithasInvoices
      setData(invoices.filter(inv => inv.due_flag == 0 && inv.approve == 1))
      setAllData(filteredAllData)
      const response = await fetchData(toggleLoading, "financeModes", token)
      if (response?.success) {
        setPaymentOption(response.data.map(obj => ({ value: obj.id, label: obj.payment_mode })))
      }
    }
  }

  useEffect(() => { fetchInvoices() }, [])

  const getPendingCustomer = async () => {
    const res = await fetchNodeData(() => { }, "invoiceRequested", token)
    if (res?.success) setPendingCustomer(res?.data)
  }

  useEffect(() => { getPendingCustomer() }, [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div>
        <Row>
          <Col lg="12">
            <Card>
              <div className="p-3" key={columnKey}>
                <TableContainer
                  columns={column1}
                  data={data}
                  allData={allData}
                  status={status}
                  setStatus={setStatus}
                  setData={setData}
                  staticPendingCustomer={pendingCustomer}
                  totalReceipts={totalReceipts}
                  setTotalReceipts={setTotalReceipts}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default DashPendingInvoices
